// removed by extract-text-webpack-plugin
module.exports = {"text":"_1h1zZvzjLukV49lDJcJ2bC","offset":"_17XBnI_tVpPdNzkRatHPQ4"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Banner/Text/styles.scss
 ** module id = 471
 ** module chunks = 0
 **/